import React, { PureComponent } from 'react';
import './WidgetMunicipal8d.css';
import PropTypes from 'prop-types';
import { translate } from '../../utils/translations';
import Header from '../../partials/Header/Header';
import Nav from '../../partials/Nav/Nav';
import DayBox from '../../partials/DayBox/DayBox';
import DayColumn from '../../partials/DayColumn/DayColumn';
import logo from '../../img/logo.png';
import { WIDGET_MARGIN_BOTTOM } from '../../utils/globals';
import Loader from '../../partials/Loader/Loader';

export class WidgetMunicipal8d extends PureComponent {
    state = {
        dayBoxes: 2,
        dayCols: 6,
        isFlexWrapped: false,
        config: {
            language: 'ca',
        },
    };

    static propTypes = {
        config: PropTypes.shape({
            location: PropTypes.string,
            language: PropTypes.string,
            color: PropTypes.string,
            variables: PropTypes.arrayOf(PropTypes.string),
            startDay: PropTypes.object,
            interval: PropTypes.number,
        }),
        data: PropTypes.object,
        cities: PropTypes.array,
        widgetDate: PropTypes.string,
    };

    render() {
        const { isFlexWrapped, dayBoxes, dayCols } = this.state;
        const { data, config } = this.props;

        if (!data.est_cel || !this.props.cities)
            return <Loader language={config.language} />;

        return (
            <div
                className="WidgetMunicipal8d mc-widget"
                style={{
                    height: `calc(100% - ${WIDGET_MARGIN_BOTTOM}px)`,
                }}
            >
                <Header color={config.color} logo={logo} />
                <div
                    className="mc-widget-wrapper"
                    style={{ height: 'calc(100% - 30px)' }}
                >
                    <Nav
                        locationCode={config.location}
                        alternativeTitle={config.alternativeTitle}
                        cities={this.props.cities}
                        language={config.language}
                        widgetDate={this.props.widgetDate}
                    />
                    <div
                        className={
                            isFlexWrapped === true || dayBoxes === 1
                                ? `mc-widget-content flex-wrapped`
                                : `mc-widget-content`
                        }
                    >
                        {data.est_cel && (
                            <DayBox
                                config={config}
                                data={data}
                                index={1}
                                dayName={translate(config.language, 'today')}
                                onlyOneDayBox={dayBoxes === 1 ? true : false}
                            />
                        )}
                        {data.est_cel &&
                            dayBoxes > 1 && (
                                <DayBox
                                    config={config}
                                    data={data}
                                    index={2}
                                    dayName={translate(
                                        config.language,
                                        'tomorrow'
                                    )}
                                />
                            )}
                        {data.est_cel &&
                            dayCols > 0 && (
                                <DayColumn
                                    config={config}
                                    data={data}
                                    index={3}
                                />
                            )}
                        {data.est_cel &&
                            dayCols > 1 && (
                                <DayColumn
                                    config={config}
                                    data={data}
                                    index={4}
                                />
                            )}
                        {data.est_cel &&
                            dayCols > 2 && (
                                <DayColumn
                                    config={config}
                                    data={data}
                                    index={5}
                                />
                            )}
                        {data.est_cel &&
                            dayCols > 3 && (
                                <DayColumn
                                    config={config}
                                    data={data}
                                    index={6}
                                />
                            )}
                        {data.est_cel &&
                            dayCols > 4 && (
                                <DayColumn
                                    config={config}
                                    data={data}
                                    index={7}
                                />
                            )}
                        {data.est_cel &&
                            dayCols > 5 && (
                                <DayColumn
                                    config={config}
                                    data={data}
                                    index={8}
                                />
                            )}
                        {!data.est_cel && (
                            <p>{translate(config.language, 'no_data')}</p>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    componentDidMount() {
        this.defineWidgetBoxesAndCols();
        window.addEventListener('resize', this.defineWidgetBoxesAndCols);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.defineWidgetBoxesAndCols);
    }

    defineWidgetBoxesAndCols = () => {
        if (this.props.preview === true) return;

        const w = window.innerWidth;
        const h = window.innerHeight;

        if (w < 237) {
            this.setState({
                dayBoxes: 1,
                dayCols: 0,
                isFlexWrapped: false,
            });
            return;
        }

        if (w >= 237 && h > 268 && h > w) {
            this.setState({
                dayBoxes: 2,
                dayCols: 6,
                isFlexWrapped: true,
            });
            return;
        }

        if (w < 260) {
            this.setState({
                dayBoxes: 2,
                dayCols: 0,
                isFlexWrapped: false,
            });
            return;
        }

        if (w < 310) {
            this.setState({
                dayBoxes: 2,
                dayCols: 1,
                isFlexWrapped: false,
            });
            return;
        }

        if (w < 360) {
            this.setState({
                dayBoxes: 2,
                dayCols: 2,
                isFlexWrapped: false,
            });
            return;
        }

        if (w < 410) {
            this.setState({
                dayBoxes: 2,
                dayCols: 3,
                isFlexWrapped: false,
            });
            return;
        }

        if (w < 460) {
            this.setState({
                dayBoxes: 2,
                dayCols: 4,
                isFlexWrapped: false,
            });
            return;
        }

        if (w < 510) {
            this.setState({
                dayBoxes: 2,
                dayCols: 5,
                isFlexWrapped: false,
            });
            return;
        }

        if (w >= 510) {
            this.setState({
                dayBoxes: 2,
                dayCols: 6,
                isFlexWrapped: false,
            });
            return;
        }
    };
}



// WEBPACK FOOTER //
// ./src/widgets/Municipal8d/WidgetMunicipal8d.js